import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const SPEC_SKELETON_COUNT: number = 4;

const SpecificationsSkeletonList = () => (
  <div className="specifications-repeater">
    {Array.from({ length: SPEC_SKELETON_COUNT }, (_, index: number) => (
      <div key={`spec-skeleton-${index}`} className="specification-card">
        <div className="specification-card-header">
          <div className="specification-card-title">
            <Skeleton variant="text" width="35%" />
          </div>
        </div>
        <div className="specification-card-body">
          <Skeleton variant="text" width="95%" />
          <div style={{ marginTop: '0.4rem' }}>
            <Skeleton variant="text" width="80%" />
          </div>
          <div style={{ marginTop: '0.4rem' }}>
            <Skeleton variant="text" width="60%" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SpecificationsSkeletonList;
